<template>
  <div class="dashboard-container">
    <!-- Loader: Top Progress Bar -->
    <div
      v-if="loading"
      class="progress-bar"
      :style="{ width: progress + '%' }"
    ></div>

    <div class="container">
      <!-- Form Title -->
      <div class="mb-2 page-title">
        <i class="bi bi-file-earmark-text"></i>
        {{ isEdit ? "Edit Match Category" : "Add Match Category" }}
      </div>

      <!-- Form -->
      <form @submit.prevent="submitForm" class="admin-form mt-4">
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-3">
              <label for="tournament_id" class="form-label">Tournament</label>
              <select
                class="form-select"
                id="tournament_id"
                v-model="form.tournament_id"
                :class="{ 'is-invalid': errors.tournament_id }"
              >
                <option value="" disabled>Choose Tournament</option>
                <option 
                  v-for="tournament in allTournaments" 
                  :key="tournament.id" 
                  :value="tournament.id"
                >
                  {{ tournament.name }}
                </option>
              </select>
              <div class="invalid-feedback">{{ errors.tournament_id }}</div>
            </div>
            <div class="mb-3">
              <label for="age_category_id" class="form-label">Age Category</label>
              <select
                class="form-select"
                id="age_category_id"
                v-model="form.age_category_id"
                :class="{ 'is-invalid': errors.age_category_id }"
              >
                <option value="" disabled>Choose Match Category</option>
                <option 
                  v-for="ageCategory in matchCategories" 
                  :key="ageCategory.id" 
                  :value="ageCategory.id"
                >
                  {{ ageCategory.name }}
                </option>
              </select>
              <div class="invalid-feedback">{{ errors.age_category_id }}</div>
            </div>

            <!--
              Kuota Tanding & Seni
              Dikosongkan = tanpa batas.
            -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="kuota_per_kelas" class="form-label">
                  Batas atlet per kelas Tanding
                </label>
                <input
                  type="number"
                  class="form-control"
                  id="kuota_per_kelas"
                  v-model="form.kuota_per_kelas"
                  :class="{ 'is-invalid': errors.kuota_per_kelas }"
                  min="2"
                  max="512"
                  placeholder="Kosongkan bila tanpa batas"
                />
                <div class="invalid-feedback">{{ errors.kuota_per_kelas }}</div>

                <small class="form-text d-block mt-2">
                  <i class="bi bi-info-circle"></i>
                  {{ penjelasanKuota }}
                </small>
              </div>

              <div class="col-md-6 mb-3">
                <label for="kuota_seni" class="form-label">
                  Batas peserta/tim per nomor Seni
                </label>
                <input
                  type="number"
                  class="form-control"
                  id="kuota_seni"
                  v-model="form.kuota_seni"
                  :class="{ 'is-invalid': errors.kuota_seni }"
                  min="2"
                  max="512"
                  placeholder="Kosongkan bila tanpa batas"
                />
                <div class="invalid-feedback">{{ errors.kuota_seni }}</div>

                <small class="form-text d-block mt-2">
                  <i class="bi bi-info-circle"></i>
                  {{ penjelasanKuotaSeni }}
                </small>
              </div>
            </div>
          </div>
        </div>
       
        
             

        <!-- Submit Button -->
        <div class="row">
          <div class="col-lg-12 text-center">
            <button type="submit" class="button button-primary" :disabled="loading">
              <i class="bi bi-floppy"></i>
              <span>{{ isEdit ? "Update Age Category" : "Add Age Category" }}</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { useToast } from "vue-toastification";

export default {
  name: "AgeCategoryForm",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      activityId: null,
      matchCategories: [],
      allTournaments: [],
      form: {
        tournament_id: "",
        age_category_id: "",
        registration_fee: "",
        kuota_per_kelas: "",
        kuota_seni: "",
      },
      errors: {},
      loading: false,
      progress: 0,
    };
  },

  computed: {
    /**
     * Menerjemahkan angka kuota jadi akibat nyatanya.
     * Panitia berpikir dalam "bagan 8", bukan "maksimal 8 peserta"; kalimat
     * di bawah menghubungkan keduanya supaya angka yang diketik tidak
     * menghasilkan bagan yang berbeda dari yang dibayangkan.
     */
    penjelasanKuota() {
      const n = Number(this.form.kuota_per_kelas);

      if (!this.form.kuota_per_kelas) {
        return 'Tanpa batas — kelas tanding bisa diisi sebanyak apa pun.';
      }
      if (!Number.isFinite(n) || n < 2) {
        return 'Isi minimal 2. Satu peserta tidak membentuk pertandingan.';
      }

      const pangkatDua = (n & (n - 1)) === 0;
      const dasar = `Setiap kelas tanding maksimal ${n} atlet.`;

      return pangkatDua
        ? `${dasar} Pas untuk bagan ${n} besar.`
        : `${dasar} Catatan: ${n} bukan kelipatan dua, jadi bagan akan berisi bye.`;
    },

    penjelasanKuotaSeni() {
      const n = Number(this.form.kuota_seni);

      if (!this.form.kuota_seni) {
        return 'Tanpa batas — nomor Seni (Tunggal, Ganda, Beregu, Solo Kreatif) bisa diisi sebanyak apa pun.';
      }
      if (!Number.isFinite(n) || n < 2) {
        return 'Isi minimal 2.';
      }

      return `Setiap nomor Seni pada kategori usia ini dibatasi maksimal ${n} peserta (Tunggal) atau ${n} tim (Ganda/Beregu).`;
    },
  },

  created() {
    this.classId = this.$route.params.id;
    this.fetchActiveTournaments();
    this.fetchAgeCategories();
    if (this.isEdit && this.classId) {
      this.fetchAgeCategoryDetail(this.classId);
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (this.isEdit && to.params.id !== this.memberId) {
      this.memberId = to.params.id;
      this.fetchMemberDetail(this.memberId);
    }
    next();
  },

  watch: {
    // Watch for changes to the memberId from the route params
    '$route.params.id': {
      immediate: true,
      handler(newId) {
        // Fetch contingent data when route param changes
        if (this.isEdit && newId) {
          this.memberId = newId;
          this.fetchAgeCategoryDetail(newId); 
        }
      },
    }
  },

  methods: {

    formatCurrency(value) {
      const number = parseInt(value);
      return new Intl.NumberFormat('id-ID', {
        maximumFractionDigits: 0, // remove .00
      }).format(number);
    },
    onInputRegistrationFee(e) {
      const raw = e.target.value.replace(/\D/g, '');
      this.form.registration_fee = this.formatCurrency(raw);
    },
    async fetchActiveTournaments() {
      await this.fetchData("/tournaments/all", "allTournaments");
    },

    async fetchAgeCategories() {
      try {
        const response = await axios.get("/age-categories");
        this.matchCategories = response.data;
      } catch (error) {
        console.error("Error fetching match-categories:", error);
      }
    },

    async fetchData(url, targetKey) {
      try {
        const response = await axios.get(url);
        this[targetKey] = response.data;
      } catch (error) {
        this.toast.error(`Failed to fetch ${targetKey}`);
      }
    },
    async fetchAgeCategoryDetail(id) {
      this.loading = true;
      try {
        const response = await axios.get(
          `/tournament-age-categories/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('authToken')}`
            }
          }
        );
        if (response.data) {
          const detail = response.data.data;
          this.form = {
            tournament_id : detail.tournament_id || "",
            age_category_id: detail.age_category_id || "",
            registration_fee: this.formatCurrency(detail.registration_fee || 0),
            // ?? bukan ||  : angka 0 tidak boleh berubah jadi string kosong.
            kuota_per_kelas: detail.kuota_per_kelas ?? "",
            kuota_seni: detail.kuota_seni ?? "",
          };

          
        }
      } catch (error) {
        this.toast.error("Error fetching class details.");
        console.error("Error fetching class details:", error);
      } finally {
        this.loading = false;
      }
    },

    
    async submitForm() {
      this.loading = true;

      try {
        const endpoint = this.isEdit
          ? `/tournament-age-categories/${this.memberId}`
          : "/tournament-age-categories";
        const method = this.isEdit ? "put" : "post";

        // Format registration_fee sebelum dikirim
        const payload = {
          tournament_id: this.form.tournament_id,
          age_category_id: this.form.age_category_id,
          registration_fee: parseInt(this.form.registration_fee.replace(/\./g, "")) || '',
          // null, bukan string kosong: peladen membedakan "tanpa batas" (null)
          // dari angka. String kosong akan gagal validasi integer.
          kuota_per_kelas: this.form.kuota_per_kelas === "" || this.form.kuota_per_kelas === null
            ? null
            : Number(this.form.kuota_per_kelas),
          kuota_seni: this.form.kuota_seni === "" || this.form.kuota_seni === null
            ? null
            : Number(this.form.kuota_seni),
        };

        await axios[method](endpoint, payload, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        });

        this.toast.success(
          this.isEdit
            ? "Tournament Match Category updated successfully!"
            : "Tournament Match Category added successfully!"
        );
        this.$router.push("/admin/tournament-age-category");
      } catch (error) {
        if (error.response && error.response.data.errors) {
          this.errors = error.response.data.errors;
          this.toast.error("An error occurred while submitting the form.");
        } else {
          this.toast.error("An error occurred while submitting the form.");
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>


<style scoped>

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 5px;
  background: var(--grad-flame);
  animation: loader-animation 1.5s infinite;
}

.page-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 20px;
}

.invalid-feedback {
  display: block;
  color: #dc3545;
}

/* Animasi garis loader */
@keyframes loader-animation {
  0% {
    width: 0;
    background: var(--grad-flame); /* Warna awal */
  }
  50% {
    width: 50%;
    background: var(--grad-flame); /* Warna saat animasi */
  }
  100% {
    width: 100%;
    background: var(--grad-flame);
  }
}
</style>
